module.exports = __webpack_public_path__ + "static/media/icon_return.996dc010.svg";